
import { defineComponent, useContext, useMeta } from '@nuxtjs/composition-api'
import { stripTags } from '@zicht/nuxt-util'
import { setupTranslationPrefixer } from '~/assets/translation'
import { getMediaSeoImage } from '~/assets/media'
import relatedPages from '~/assets/relatedPages'

export default defineComponent({
  mixins: [relatedPages],
  props: {
    page: { type: Object, required: true },
  },
  setup(props) {
    const {
      app: { i18n },
    } = useContext()

    // Hide subscribe button if event date has passed
    const eventHasPassed = new Date(props.page.dateEnd ? props.page.dateEnd : props.page.date) < new Date(new Date().setHours(0, 0, 0))

    const startDateIso = new Date(props.page.date).toISOString()
    const endDateIso = props.page.dateEnd ? new Date(props.page.dateEnd).toISOString() : undefined
    const infoPanelItems = [
      {
        title: i18n.t('event-page.default.date'),
        type: 'date',
        startDate: i18n.d(new Date(props.page.date), 'long-date'),
        startDateTime: startDateIso,
        endDate: props.page.dateEnd ? i18n.d(new Date(props.page.dateEnd), 'long-date') : undefined,
        endDateTime: endDateIso,
      },
      { title: i18n.t('event-page.default.time'), value: props.page.time },
      { title: i18n.t('event-page.default.location'), value: props.page.location },
      { title: i18n.t('event-page.default.costs'), value: props.page.cost },
    ]

    // Only send an item to the InfoPanel component if the item actually has a value
    const filteredInfoPanelItems = infoPanelItems.filter((i) => i.value || (i.type === 'date' && i.startDate))

    // Build the Schema.org data
    const schemaData = {
      '@context': 'https://schema.org/',
      '@type': 'Event',
      url: props.page.url,
      name: props.page.title,
      description: props.page.introduction ? stripTags(props.page.introduction) : null,
      startDate: startDateIso,
      endDate: endDateIso || startDateIso,
      location: { '@type': 'Place', name: props.page.location },
      image: getMediaSeoImage(props.page.image).url,
    }
    useMeta({ __dangerouslyDisableSanitizers: ['script'], script: [{ type: 'application/ld+json', innerHTML: JSON.stringify(schemaData) }] })

    return {
      filteredInfoPanelItems,
      eventHasPassed,
      ...setupTranslationPrefixer('event-page'),
    }
  },
  head: {},
})
